var _path;

import * as React from "react";

function SvgSwap(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.497 25.5H8.952l4.643-4.977a1.494 1.494 0 00-.07-2.116 1.494 1.494 0 00-2.12.068l-6.999 7.5a1.497 1.497 0 000 2.046l7 7.5a1.493 1.493 0 002.117.073 1.498 1.498 0 00.072-2.119L8.952 28.5h25.545a1.5 1.5 0 000-3zM5.5 14.5h25.548l-4.643 4.977a1.498 1.498 0 00.072 2.12 1.495 1.495 0 002.12-.073l6.999-7.5a1.497 1.497 0 000-2.046l-7-7.5a1.505 1.505 0 00-2.122-.072 1.498 1.498 0 00-.072 2.119l4.646 4.976H5.5c-.828 0-1.5.675-1.5 1.5s.672 1.5 1.5 1.5z"
  })));
}

export default SvgSwap;